import {axios} from '@/lib/axios';

const apiRoot = '/api/v1/datas/'

export const getDrmInformationList = (order: string) => {
  return axios.get(apiRoot + 'getDrmInformationList', {
    params: {order}
  })
}

export const getDrmInformation = (id: number) => {
  return axios.get(apiRoot + 'getDrmInformation', {
    params: {id}
  })
}

export const getSearchConditionList = () => {
  return axios.get(apiRoot + 'getDrmInformationTypes')
}